import { CSSProperties } from 'react'

export const ImageCellNoText = (props: {
  image_url: string | undefined
  default_image_url?: string | undefined
  image_size?: string | undefined
  onClick?: () => void
  style?: CSSProperties
}) => {
  let placeHolderUrl = `${import.meta.env.VITE_STATIC_IMAGES_URL}/images/placeholder.png`
  const fallbackSize = '100px'

  return (
    <img
      className="rounded-md"
      src={props.image_url || props.default_image_url || placeHolderUrl}
      alt="image cell"
      onClick={props.onClick}
      onError={e => {
        ;(e.target as HTMLImageElement).src = props.default_image_url || placeHolderUrl
      }}
      style={{
        height: props.image_size || fallbackSize,
        width: props.image_size || fallbackSize,
        ...props.style,
      }}
    />
  )
}
